import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, } from "@heroui/react"; import * as OlaLeadsAction from '../../redux/actions/olaLeadsAction';
import { bindActionCreators } from 'redux';
import UploadFile from '../../components/UploadFile/UploadFile';
import { ImportIcon } from '../../utils/svgIcons';


const LeadVerification = () => {
    const dispatch = useDispatch();

    const [manualModalIsOpen, setManualModalIsOpen] = useState(false);

    const { verifyLeadStatus } = bindActionCreators(
        OlaLeadsAction,
        dispatch
    );

    let leadType = 'RevoltTvsLeadverification'

    const handleUploadFile = () => {
        setManualModalIsOpen(true);
    };

    const handleUpload = async (formData) => {
        return await verifyLeadStatus(formData);
    };

    return (
        <div className="inline-flex overflow-hidden max-w-full w-full  rounded-global shadow-global">
            <div className="shadow-none px-6 py-6 rounded-outSideglobal w-full overflow-x-auto default-scrollbar bg-white overflow-hidden MuiBox-root css-0">
                <div className='flex flex-col gap-5'>
                    <div className="flex flex-col gap-2">
                        <h1 className="text-2xl font-semibold text-gray-800">
                            Upload Revolt & TVS Leads for Verification
                        </h1>
                        <p className="text-base text-gray-600">
                            Please upload your Excel file containing the leads. You'll get a downloadable file with accepted leads.
                        </p>
                    </div>

                    <div className=''>
                        <Button
                            className={`hover:bg-button font-mediem text-medium hover:border-secondary border-1 border-gray-200 text-gray-500 hover:text-white transition-colors duration-500 ${manualModalIsOpen ? "bg-button text-white border-secondary" : "hover:bg-button hover:border-secondary hover:text-white"}`}
                            variant="bordered"
                            startContent={<ImportIcon width="22px" height="22px" />}
                            onPress={handleUploadFile}
                        >
                            Import Excel File
                        </Button>
                        <UploadFile
                            leadType={leadType}
                            isOpen={manualModalIsOpen}
                            setManualModalIsOpen={setManualModalIsOpen}
                            onOpen={() => setManualModalIsOpen(true)}
                            onClose={() => setManualModalIsOpen(false)}
                            onUpload={handleUpload}
                            isGenerateSample={true}
                        />
                    </div>

                </div >
            </div>
        </div>
    );
};

export default LeadVerification;